import axios from "axios";
import { IPixabay } from "../types/pixabay";
import { toCamelCase } from "../utils/objectHelper";

export const PixabayTransport = {
    list: async (search: string, page?: number): Promise<IPixabay> => {
        const { data } = await axios.get(`/pixabaySearch?search=${search}&page=${page}`, {});
        return toCamelCase(data);
    },
};
